export async function getGoogle(config, mapsApiKey: string | undefined) {
  return new Promise((resolve, reject) => {
    if (!mapsApiKey) {
      return reject(new Error('google maps api key not provided!'));
    }

    window.__googleMapsLoaded = () => {
      resolve(window['google']);
      const event = new CustomEvent('google-map-loaded', {});
      document.dispatchEvent(event);
      // call callback from config if callable
      if (config.cb && typeof window[config.cb] === 'function') {
        window[config.cb]();
      }
      // clean up
      delete window.__googleMapsLoaded;
    };

    if (!document.getElementById('google-map-script')) {
      const url = 'https://maps.googleapis.com/maps/api/js';
      // a global callback must be provided to the google api script
      // https://developers.google.com/maps/documentation/javascript/url-params#required_parameters

      const params = {
        key: mapsApiKey,
        client: config.client || null,
        callback: '__googleMapsLoaded',
        libraries: config.libraries?.join(',') || ['places'],
        v: config.version || '3.53',
        channel: config.channel || null,
        language: config.language || null,
        region: config.region || null,
        loading: 'async',
      };
      const paramStr = Object.keys(params)
        .filter((key) => !!params[key])
        .map((key) => `${key}=${params[key]}`)
        .join('&');

      const script = document.createElement('script');
      script.src = `${url}?${paramStr}`;
      script.id = 'google-map-script';
      script.async = true;
      script.addEventListener('error', reject, { once: true });

      document.body.appendChild(script);
    }
  });
}
